import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'

import { proxiedGet, proxiedPost, proxiedPut, proxiedPatch, buildQueryObject } from 'Services/apiClient'

const CreatePaymentData = (uuid, countryCode3alpha, aliasName = null) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/hydra-value/feelGreat/${StoreCountry.Country3()}`

    const data = {
        uuid: uuid,
        source_path: window.location.href
    }

    if (aliasName) {
        data.alias_name = aliasName
    }

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const CreatePaymentLambdaData = (uuid, countryCode3alpha) => {
    const isDev = ServerEnv.ENV === 'DEV'
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/format/${StoreCountry.Country3()}/feelGreat/detail-hydra-v2/${uuid}${isDev ? '?dev=1' : ''
        }`

    return proxiedGet(url, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const CreateMemberAndOrder = hydraData => {
    const url = `${ServerEnv.Hydra()}/orders`

    return proxiedPost(url, hydraData, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const CreateOrder = (hydraData, token, Language, c) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`
    return proxiedPost(url, hydraData, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

// const CreateOrderWithCustomerHref = (hydraData, token, customerHref) => {
//     const url = `${ServerEnv.Hydra()}/customers/${customerHref}/orders`
//     return proxiedPost(url, hydraData, {
//         config: {
//             headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: `Bearer ${token}`,
//                 'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
//             }
//         }
//     })
// }

const CreateOrderAndSubscriptions = (hydraData, token, Language, c) => {
    const url = `${ServerEnv.Hydra()}/customers/me/ordersAndSubscriptions?async=false`
    return proxiedPost(url, hydraData, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const CreateLambdaOrder = (lambdaData, token, Language, c) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`
    return proxiedPost(url, lambdaData, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    })
}

const CreateWorldPayOrder = (hydraData, token) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`

    return proxiedPost(url, hydraData, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const CreateAutoship = (autoOrder, token) => {

}

const PostSms = dataSms => {
    const smsApi = `https://${ServerEnv.MemberCalls2()}.unicity.com/sms-api/sms`

    proxiedPost(smsApi, dataSms, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }).catch(error => console.error(error))
}

const UpdateLog = (data, isCreateSubscribe = 0, countryCode3Alpha) => {
    // SG & MY credit-card-alias subscribe orders need ?isCreateSubscribe=1 to create the legitimate autoship.
    // Scoped to these markets only: JP/PH/TH must stay without it to avoid re-introducing the ghost-autoship bug (commit 34f19938).
    const needsCreateSubscribeQuery = isCreateSubscribe && ['SGP', 'MYS'].includes(countryCode3Alpha) // When using API ordersAndSubscription, do not send the ?isCreateSubscribe=1 query parameter.
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/hydra-log${needsCreateSubscribeQuery ? '?isCreateSubscribe=1' : ''}` 

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const PostEmail = dataEmail => {
    const emailApi = `https://${ServerEnv.MemberCalls2()}.unicity.com/email-api/message`

    proxiedPost(emailApi, dataEmail, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }).catch(error => console.error(error))
}

const CustomerLogin = (username, password, timeout = 0) => {
    const data = {
        type: 'base64',
        value: btoa(`${username}:${password}`),
        namespace: `${ServerEnv.Hydra()}/customers`
    }

    const url = `${ServerEnv.Hydra()}/loginTokens`

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const GetPaymentDetail = (paymentId, baId) => {
    const data = {
        payment_id: paymentId,
        type: baId ? 'shop' : 'enroll',
        ba_id: baId || ''
    }
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/detail/hydra`

    return proxiedPost(url, data)
}

const GetPaymentProxyDetail = gateway_ref_id => {
    const data = {
        gateway_ref_id: gateway_ref_id
    }
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/detail/proxy`

    return proxiedPost(url, data)
}

const UpdateLogByOrder = data => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/hydra-log-by-order`

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const GetOrderDetailByOrderNumber = orderNumber => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/order/data`

    return proxiedGet(url, {
        params: { order_number: orderNumber }
    })
}

const RequestWorldPayDDC = bin => {
    const url = `${ServerEnv.Hydra()}/ddc`
    return proxiedPost(
        url,
        {
            bin
        },
        {
            config: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
                }
            }
        }
    )
}

const GetHydraOrderDetail = async (orderNunber, token) => {
    const url = `${ServerEnv.Hydra()}/orders`
    return proxiedGet(url, {
        params: { 'id.unicity': orderNunber },
        config: {
            headers: {
                Authorization: `Bearer ${token}`,
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const UpdateLambdaAutoshipLog = data => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/proxy-log-autoship`

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const UpdateHydraAutoshipLog = data => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/hydra-log-autoship`

    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const CreatePaymentDataForHostedGateway = (data, is3ds = false) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`

    return proxiedPost(url, data, {
        params: is3ds ? { is3ds: 1 } : undefined,
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const GetQRDetail = id => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/2c2p/qrPaymentStatus/${id}`

    return proxiedGet(url)
}

const PollQRTransactionStatus = (inquiry) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/2c2p/transaction-status`

    return proxiedPost(url, inquiry)
}

const ConfirmQRPayment = ({ frontendReturnUrl, frontendReturnData }) => {
    const url = 'https://shop.unicity.com/api/payments/2c2p/confirm-payment'

    return proxiedPost(url, { frontendReturnUrl, frontendReturnData })
}

const CreateUuid = (data, countryCode3Alpha, skipValidateTaxInvoice = null) => {
    const params = skipValidateTaxInvoice ? { skipValidateTaxInvoice: 1 } : undefined
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/${countryCode3Alpha}/feelGreat/address`
    return proxiedPost(url, data, { params })
}

const UpdateUUid = (data, countryCode3Alpha, isSkipValidateAddress) => {
    const params = isSkipValidateAddress ? { isSkipValidate: 1 } : undefined
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/${countryCode3Alpha}/feelGreat/address`

    return proxiedPut(url, data, { params })
}

const CreateAccountAndUuid = (data, countryCode3Alpha) => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/${countryCode3Alpha}/feelGreat/createAccount`

    return proxiedPost(url, data, {
        params: { emailDelay: '1h' }
    })
}

const CreateAccountAndUpdateUuid = (data, countryCode3Alpha, debug) => {
    const params = buildQueryObject(
        { emailDelay: '1h', isSkipValidateAddress: 1, isValaidateUUID: 1 },
        debug ? { debug: 1 } : null
    )
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/${countryCode3Alpha}/feelGreat/createAccount`

    return proxiedPost(url, data, { params })
}

const UpdateReadyToCreateOrder = data => {
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/payment_router/proxy/update/status`

    return proxiedPatch(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const CreateCustomer = data => {
    const url = `${ServerEnv.Hydra()}/customers`
    return proxiedPost(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
            }
        }
    })
}

const CustomerInformationUpdate = ({ token, customer_href, customer_information }) => {
    const data = {
        token,
        customer_href,
        customer_information
    }
    const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/customer/information`
    return proxiedPatch(url, data, {
        config: {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

const SaveCardAlias = (cardData, countryCode2Alpha, token) => {
    const url = `${ServerEnv.HydraV6()}/customers/me/creditcardaliases/${countryCode2Alpha}`
    return proxiedPost(url, cardData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
        }
    })
}

const checkCardAlias = (cardHref, token) => {
    const url = `${cardHref}`
    return proxiedGet(url, {
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.fg.${StoreCountry.Country2().toLowerCase()}`
        }
    }
    )
}

export const PaymentAPIs = {
    CreatePaymentData,
    CreatePaymentLambdaData,
    CreateMemberAndOrder,
    CreateOrder,
    // CreateOrderWithCustomerHref,
    CreateOrderAndSubscriptions,
    CreateLambdaOrder,
    PostSms,
    UpdateLog,
    PostEmail,
    CustomerLogin,
    GetPaymentDetail,
    GetPaymentProxyDetail,
    CreateAutoship,
    UpdateLogByOrder,
    GetOrderDetailByOrderNumber,
    CreateWorldPayOrder,
    RequestWorldPayDDC,
    GetHydraOrderDetail,
    UpdateLambdaAutoshipLog,
    UpdateHydraAutoshipLog,
    CreatePaymentDataForHostedGateway,
    GetQRDetail,
    PollQRTransactionStatus,
    ConfirmQRPayment,
    CreateUuid,
    CreateAccountAndUuid,
    CreateAccountAndUpdateUuid,
    UpdateReadyToCreateOrder,
    CustomerInformationUpdate,
    CreateCustomer,
    UpdateUUid,
    SaveCardAlias,
    checkCardAlias
}
